import { render, staticRenderFns } from "./pageRelatedConfiguration.vue?vue&type=template&id=33ca3e26&scoped=true"
import script from "./pageRelatedConfiguration.vue?vue&type=script&lang=ts"
export * from "./pageRelatedConfiguration.vue?vue&type=script&lang=ts"
import style0 from "./pageRelatedConfiguration.vue?vue&type=style&index=0&id=33ca3e26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ca3e26",
  null
  
)

export default component.exports